
(() => {
 const mounted = new WeakMap();
 function mount(hero) {
  if (mounted.has(hero)) return;
  const controller = new AbortController(), signal=controller.signal;
  const media=matchMedia('(max-width:899px)');
  const update=()=>{
   hero.querySelectorAll('video').forEach(video=>{
    if(!media.matches){video.style.removeProperty('--mobile-video-offset');return}
    if(!video.videoWidth||!video.videoHeight)return;
    const box=video.getBoundingClientRect();
    const renderedWidth=Math.max(box.width,box.height*video.videoWidth/video.videoHeight);
    const maxShift=Math.max(0,(renderedWidth-box.width)/2);
    const desired=Number(hero.dataset.mobileVideoShift || 130);
    video.style.setProperty('--mobile-video-offset',Math.max(-maxShift,Math.min(maxShift,desired))+'px');
   });
  };
  hero.querySelectorAll('video').forEach(v=>v.addEventListener('loadedmetadata',update,{signal}));
  media.addEventListener('change',update,{signal});
  const observer=new ResizeObserver(update);observer.observe(hero);
  mounted.set(hero,{controller,observer});update();
 }
 const init=scope=>scope.querySelectorAll('[data-mobile-video-shift]').forEach(mount);
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{
  event.target.querySelectorAll('[data-mobile-video-shift]').forEach(hero=>{
   const record=mounted.get(hero);record?.controller.abort();record?.observer.disconnect();mounted.delete(hero);
  });
 });
})();
